module.exports = __webpack_public_path__ + "img/list_mail_normal.85116a60.svg";